module.exports = __webpack_public_path__ + "static/media/icon-plus.499c0f84.svg";